<script setup="">
import { computed, inject } from "vue";

const props = defineProps({
  defaultClass: {
    type: String,
    required: false,
    default: "py-6 px-4 sm:px-6 lg:py-12"
  },
  classes: {
    type: String,
    required: false
  },
  size: {
    type: String,
    required: false
  },
  fluid: {
    type: Boolean,
    required: false
  },
  section: {
    type: Boolean,
    required: false
  },
  centered: {
    type: Boolean,
    required: false,
    default: true
  }
});

const twMerge = inject("twMerge");

const containerSize = computed(() => {
  switch (props.size) {
    case "xs":
      return "max-w-screen-xs";
    case "sm":
      return "max-w-screen-sm";
    case "md":
      return "max-w-screen-md";
    case "lg":
      return "max-w-screen-lg";
    case "xl":
      return "max-w-screen-xl";
    case "2xl":
      return "max-w-screen-2xl";
    default:
      return "max-w-4xl 2xl:max-w-screen-lg";
  }
});

const computedClass = computed(() => twMerge(props.defaultClass, props.centered ? "mx-auto" : "", containerSize.value, props.classes));
</script>

<template>
  <div class="relative w-full" :class="{ 'rounded-xl bg-white shadow-soft': section }">
    <slot name="header" />

    <div class="content-container w-full" :class="{ 'p-6 bg-50': section }">
      <div class="w-full" :class="[fluid ? '' : computedClass]">
        <slot />
      </div>
    </div>
  </div>
</template>
